import { FILTERED_SECTION_BY_MENU } from "./../types";

export const filteringSectionByMenu = (data) => ({
    type: FILTERED_SECTION_BY_MENU,
    payload: data
})